var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.countryCode === "us"
    ? _c(
        "div",
        { staticClass: "ui-form-row", attrs: { id: "program-grade-div" } },
        [
          _c("checkboxes", {
            attrs: {
              label: _vm.t("app-program-grade-program-serves"),
              options: _vm.options,
              required: true,
              cols: 3,
            },
            model: {
              value: _vm.program.attributes.field_program_grades_served,
              callback: function ($$v) {
                _vm.$set(
                  _vm.program.attributes,
                  "field_program_grades_served",
                  $$v
                )
              },
              expression: "program.attributes.field_program_grades_served",
            },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }